import {defineStore} from 'pinia'
import api from '@/services/api'
import {useNavigationStore} from "@/stores/navigation"
import {useComponentStructureStore} from "@/stores/componentStructure"
import {useItemDataStore} from "@/stores/itemData"

export const useComponentsStore = defineStore('components', {
    state: () => ({
        componentIds: false,
        items: []
    }),
    
    getters: {
        nameField: (state) => (componentId) => {
            const componentStructureStore = useComponentStructureStore()
            const component = state.items.find(o => o.id === componentId)
            if (!component) return 'id'
            
            let nameField = 'id'
            const structureFields = componentStructureStore.get(componentId) || []
            
            if (component.nameField) {
                const field = structureFields.find(o => o.id === component.nameField)
                nameField = field ? field.columnName : 'id'
            } else if (component.displayName) {
                nameField = 'displayName'
            } else if (structureFields.find(o => o.columnName === 'title')) {
                nameField = 'title'
            }
            
            return nameField
        }
    },
    
    actions: {
        async init() {
            const itemDataStore = useItemDataStore()
            
            const response = await api.get('api/component/modulecomponents', {
                params: {
                    sort: 'displayOrder'
                }
            })
            
            const items = response.data.items
            
            itemDataStore.setItems({
                tableName: 'modulecomponents',
                objs: items,
            })
            
            this.items = items
            
            const componentIds = {}
            items.forEach((item) => {
                componentIds[item.tableName] = item.id
            })
            this.componentIds = componentIds
            
            const navigationStore = useNavigationStore()
            navigationStore.setGroupsComponents()
        }
    }
})